import React from "react";
import styles from './form.module.css'

const Textarea = ({ placeholder, value, onChange, className = "", theme, style, rows, required, elementRef, autoFocus = false, maxLength, disabled = false, ...props }) => {
    return (
        <textarea
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className={`${styles.textarea} ${styles[className] || ""} ${styles[theme] || ""} ${className}`.trim()}
            style={style}
            required={required}
            autoFocus={autoFocus}
            rows={rows}
            tabIndex={1}
            ref={elementRef}
            maxLength={maxLength}
            disabled={disabled}
            {...props}
        >{value}</textarea>
    )
}

export default Textarea
